export const URLS = {
  AUTH_HOME: '/',
  AUTH_LEADS: '/leads',
  AUTH_LEAD: ':id/*',
  AUTH_LEAD_DETAILS: 'details',
  AUTH_LEAD_NOTES: 'notes',
  AUTH_LEAD_CHECKLISTS: 'checklists',
  AUTH_LEAD_SPEND: 'spend',
  AUTH_DASHBOARD: '/dashboard',
  LOGIN: '/login',
  ORGANIZATION_REGISTRATION: '/registration',
  AUTH_LOGOUT: '/logout',
  AUTH_DEALS: '/opportunities/',
  AUTH_DEALS_LIST: 'list',
  AUTH_DEALS_BOARD: 'board',
  AUTH_DEAL: '/opportunities/:id',
  AUTH_ROUTES_DEAL: '/opportunities/:id/*',
  AUTH_DEAL_DETAILS: 'details',
  AUTH_DEAL_PROPOSALS: 'proposals',
  AUTH_DEAL_DOCUMENTS: 'documents',
  AUTH_DEAL_TASKS: 'tasks',
  AUTH_DEAL_CHECKLISTS: 'checklists',
  AUTH_DEAL_ESTIMATING: 'estimating',
  AUTH_DEAL_ANALYSIS: 'analysis',
  AUTH_DEAL_TIMETRACKER: 'timetracker',
  AUTH_DEAL_ACTIVITY: 'activity',
  AUTH_DEAL_NOTES: 'notes',
  AUTH_PROPOSALS: '/proposals',
  AUTH_PROPOSAL: '/proposals/:id',
  AUTH_CONTACTS: '/contacts',
  AUTH_COMPANIES: '/companies',
  AUTH_COMPANY: '/companies/:id',
  AUTH_CONTACT: '/contacts/:id',
  AUTH_LISTS: '/lists',
  AUTH_CALENDAR: '/calendar',
  AUTH_ADMIN: '/admin',
  RESET_PASSWORD: '/reset-password',
  CHANGE_PASSWORD: '/change-password',
  AUTH_GLOBAL_SEARCH: '/search',
  AUTH_REPORTS: '/reports',
  AUTH_ROUTES_REPORTS: 'reports/*',
  AUTH_TIME_TRACKING: '/time-tracking'
}

export const COOKIES = {
  DATE_RANGE_FILTERS: 'ideal-date-range-filters',
  FOLLOWUP_DATE_RANGE_FILTERS: 'ideal-followup-date-range-filters',
  LAST_TOUCHED_DATE_RANGE_FILTERS: 'ideal-last-touched-date-range-filters',
  USERS_FILTERS: 'ideal-users-filter',
  DEALS_ADDITIONAL_FILTERS: 'ideal-deals-additional-filters'
}

export const URL = {
  development: 'https://api.dev.idealcrm.app',
  uat: 'https://api.dev.idealcrm.app',
  production: 'https://api.web.idealcrm.app'
}

export const REPORTS_URL = {
  development: 'https://reporting.dev.idealcrm.app',
  uat: 'https://reporting.dev.idealcrm.app',
  production: 'https://reporting.web.idealcrm.app'
}

export const LEADS_URL = {
  development: 'https://leads.dev.idealcrm.app',
  uat: 'https://leads.dev.idealcrm.app',
  production: 'https://leads.web.idealcrm.app'
}

export const CLIENT_URL = {
  development: 'http://localhost:8080',
  uat: 'https://dev.idealcrm.app',
  production: 'https://web.idealcrm.app'
}

export const SYNCFUSION_URL = {
  development: 'https://test-ideal-syncfusion.azurewebsites.net',
  uat: 'https://test-ideal-syncfusion.azurewebsites.net',
  production: 'https://prod-ideal-sybcfusion.azurewebsites.net'
}

export const PAYMENT_URL = {
  development: 'https://payments.dev.idealcrm.app',
  uat: 'https://payments.dev.idealcrm.app',
  production: 'https://payments.web.idealcrm.app'
}

export const APP_CONSTANTS = {
  DealDocumentType: {
    BID_DOCUMENT: 'Bid Document',
    RFI_DOCUMENT: 'RFI Document'
  },
  DealPriority: {
    NORMAL: 'Normal',
    URGENT: 'Urgent',
    HIGHPRIORITY: 'High Priority',
    LOWPRIORITY: 'Low Priority'
  },
  DealHealth: {
    ONTRACK: 'On Track',
    SLIPPING: 'Slipping',
    AHEAD: 'Ahead of Schedule',
    WARNING: 'Warning - Danger'
  },
  DealSize: {
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
    XLARGE: 'X-Large'
  },
  DealClientRole: {
    DECISION: 'Decision Maker',
    MANAGER: 'Project Manager',
    ENGINEER: 'Project Engineer',
    PROPOSALRECEIVER: 'Proposal Receiver',
    LEGAL: 'Legal / Contract Admin',
    SECRETARY: 'Secretary / Admin',
    PRESIDENT: 'President',
    ESTIMATOR: 'Estimator'
  },
  ProposalStatus: {
    CREATION: 'Proposal Creation',
    CHANGES: 'Proposal Changes',
    INTERNALREVIEW: 'In Internal Review',
    READYTOSEND: 'Ready to Send',
    SENT: 'Sent',
    RECEIVED: 'Received',
    YY: 'Won - New Job',
    YN: 'Lost by Us',
    NN: 'Lost by Client(s)',
    NY: 'Lost by Client Won by Us',
    ARCHIVED: 'Archived'
  },
  ProposalSigned: {
    NO: 'No',
    YES: 'Yes'
  },
  TaskTypes: {
    CALL: 'Call',
    EMAIL: 'Email',
    TASK: 'Task',
    MEET: 'Meet',
    LUNCH: 'Lunch',
    DINNER: 'Dinner'
  },
  CompanySize: {
    S: '0 - 100K',
    M: '100K - 500K',
    L: '500K - 1M',
    XL: '1M - 5M',
    XXL: '5M and Up'
  },
  EntityType: {
    DEAL: 'Deal',
    PROPOSAL: 'Proposal',
    COMPANY: 'Company',
    CONTACT: 'Contact',
    REPORT: 'Report',
    TASK: 'Task',
    NOTE: 'Note'
  },
  OrganizationSize: {
    S: '1-2',
    M: '3-5',
    L: '6-10',
    XL: '11-25',
    XXL: '25+'
  },
  OrganizationType: {
    CONTRACTOR: 'Contractor / Subcontractor',
    GC: 'General Contractor',
    AE: 'AE Firm',
    SUPPLIER: 'Material Supplier',
    INSURANCE: 'Insurance Company',
    OTHER: 'Other'
  },
  OrganizationInterest: {
    TRACKING: 'Tracking multiple bids & clients for one opportunity',
    EXPEDITE: 'Need to expedite proposal creation',
    STREAMLINE: 'Need to streamline & automate follow-up activities',
    TIME: 'Manual work is too time consuming',
    CENTRALIZE: 'Sales information is not centralized or siloed',
    OTHER: 'Other'
  }
}

export const EMAIL_TEMPLATE_TYPE = {
  COMPANY_OPEN_OPPORTUNITIES: 'company_open_opportunities',
  CONTACT_OPEN_OPPORTUNITIES: 'contact_open_opportunities'
}

export const DEAL_BOARD_PAGE_SIZE = 20

export const TABLE_PAGE_SIZE = 50
export const TABLE_ROW_SERVER_SIDE_MODEL = 'serverSide'

export const ZENDESK_KEY = '15c69f46-c5bb-469c-8ebc-e248d81adb8b'

export const INTEGRATIONS = {
  MAIL: {
    IDEAL: 'IDEAL',
    OFFICE365: 'OFFICE365',
    SMTP: 'SMTP',
    NON_PAYING: 'NON_PAYING'
  },
  CONNECTION_MODE: [
    {
      value: 'NONE',
      label: 'No security. Not recommended'
    },
    {
      value: 'SSL',
      label: 'SSL/TLS'
    },
    {
      value: 'STARTTLS',
      label: 'STARTTLS'
    }
  ]
}

export const DATE_FORMAT = {
  MONTH_DAY_YEAR: 'MM/DD/YYYY',
  DAY_MONTH_YEAR: 'DD/MM/YYYY',
  YEAR_MONTH_DAY: 'YYYY/MM/DD'
}

export const FNS_DATE_FORMAT = {
  MONTH_DAY_YEAR: 'MM/dd/yyyy',
  DAY_MONTH_YEAR: 'dd/MM/yyyy',
  YEAR_MONTH_DAY: 'yyyy/MM/dd'
}

export const HAS_FOLLOWUP_DATE_STAGES = ['followup', 'closed', 'project', 'lead']

export const HELP_USER = {
  firstName: 'ZiDeal',
  lastName: 'Help',
  roles: ['ROLE_USER', 'ROLE_ADMIN']
}

export const CLOSED_CATEGORIES = ['closed', 'project', 'won', 'lost']

export const BID_SUBMISSION_STATUS = {
  EARLY: 'Submitted Early',
  ONTIME: 'Submitted On Time',
  LATE: 'Submitted Late',
  PASTDUE: 'Not Submitted - Past Due',
  UPCOMING: 'Not Submitted - Upcoming'
}

export const EMAIL_SPLIT_MODE = {
  SPLIT_ALL: 'Split Emails (for email campaigns)',
  GROUP: 'Group by Company',
  NO_SPLIT: 'Group All Contacts on 1 Email',
  NO_SPLIT_LEADS: 'Group All Leads on 1 Email'
}

export const EMAIL_LEADS_SPLIT_MODE = {
  NO_SPLIT: 'Group All Leads on 1 Email'
}

export const TOKEN_KEY = 'ideal-auth-token'
export const PAYMENT_KEY = 'ideal-payment-overdue-date'
export const MODULES_KEY = 'ideal-modules'

// Impersonation helpers
export const IMPERSONATION_TOKEN_KEY = 'impersonationToken'
export const IMPERSONATOR_EMAIL_KEY = 'impersonatorEmail'
